export default "__VITE_ASSET__a0df2c0d__"